

import Home from './components/Home'

// Sync route definition
export default {
  component : Home
}


// WEBPACK FOOTER //
// ./src/routes/Home/index.js